var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card mt-2" }, [
    _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v(_vm._s(_vm.item.tipo))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card__content" },
      [
        _vm._l(_vm.item.grupos, function(proceso, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.item.grupos.length > 0,
                  expression: "item.grupos.length > 0"
                }
              ],
              key: index
            },
            [
              proceso !== null
                ? _c("item-grupo-contenedor", {
                    attrs: { title: proceso.grupo, imagenes: proceso.imagenes },
                    on: { verImagen: _vm.verImagen }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.item.grupos.length === 0
          ? _c("div", { staticClass: "mb-2" }, [
              _c("strong", [_vm._v(_vm._s(_vm.$t("message.sinDatos")))])
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-793803df", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793803df","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/clientes/ItemContenedor.vue
// module id = 308
// module chunks = 0